// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-1YAWA";
var _4 = "codeInput-13DV6";
var _5 = "button-46FJB";
var _6 = "title-bn3Zw";
var _7 = "button_applied-2-qr5";
var _8 = "button_notApplied-1QFJ5";
var _9 = "button_empty-3PJKh";
var _a = "statusMessage-23Hdf";
var _b = "statusMessage_applied-3AuQv";
var _c = "statusMessage_notApplied-e2bwz";
var _d = "form_additionalFields-LUbGm";
var _e = "statusText-2Qidu";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "codeInput", _5 as "button", _6 as "title", _7 as "button_applied", _8 as "button_notApplied", _9 as "button_empty", _a as "statusMessage", _b as "statusMessage_applied", _c as "statusMessage_notApplied", _d as "form_additionalFields", _e as "statusText" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "codeInput": _4, "button": _5, "title": _6, "button_applied": _7, "button_notApplied": _8, "button_empty": _9, "statusMessage": _a, "statusMessage_applied": _b, "statusMessage_notApplied": _c, "form_additionalFields": _d, "statusText": _e }
